export default function getLocation () {
  if (navigator.geolocation) {
    return new Promise(function (resolve, reject) {
      const locationError = function (error) {
        switch (error.code) {
          case error.TIMEOUT:
            alert('A timeout occured! Please try again!')
            break
          case error.POSITION_UNAVAILABLE:
            alert('We can\'t detect your location. Sorry!')
            break
          case error.PERMISSION_DENIED:
            alert('Please allow geolocation access for this to work.')
            break
          case error.UNKNOWN_ERROR:
            alert('An unknown error occured!')
            break
        }
      }
      const locationSuccess = function (position) {
        // var coords = position.coords
      }
      navigator.geolocation.getCurrentPosition(locationSuccess, locationError, {
        // 指示浏览器获取高精度的位置，默认为false
        enableHighAccuracy: true,
        // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
        timeout: 5000,
        // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
        maximumAge: 3000
      })
    })
  } else {
    alert('Your browser does not support Geolocation!')
  }
}



// WEBPACK FOOTER //
// ./src/utils/loaction.js